import { InfoOutlined, Lock } from "@mui/icons-material";
import { TextField, Tooltip } from "@mui/material";
import { Field, ErrorMessage } from 'formik';
import { IconButton } from "@mui/material";
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { useState } from "react";


const PasswordTextInput = ({ customChange, floatingLabel = false, preventFormikSetValue = false, ...props }) => {

    const [showPassword, setShowPassword] = useState(false);
    const handleClickShowPassword = () => setShowPassword((show) => !show);
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
      };

	return (
        <div>
            { !floatingLabel && <label className="label">{props.label} {props.required && '*'} { props.readOnly && <Lock fontSize="10px" style={{ marginBottom: '-2px' }} />} {props.tip && <Tooltip title={props.tip} ><InfoOutlined fontSize="10px" style={{ marginBottom: '-2px' }} /></Tooltip>}</label> }
            <Field id={props.id} name={props.id} label={props.label}>
                {({ field, form }) => (
                    <div>
                        <TextField 
                            { ...props }
                            id={props.id}
                            name={props.id}
                            label={floatingLabel ? props?.label || '' :null}
                            disabled={props.disabled}
                            type={showPassword ? 'text' : 'password'}
                            required={props.required} 
                            placeholder={props?.placeholder || `Enter ${props.label}`}
                            InputProps={{
                              readOnly: props.readOnly,
                              endAdornment: <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                                size="large"
                              >
                                {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                              </IconButton>
                            </InputAdornment>,
                              ...props.InputProps
                            }}
                            inputProps={{
                                ...props.inputProps
                            }}
                            multiline={props.multiline} minRows={props.minRows}
                            variant="outlined"
                            fullWidth
                            error={Boolean(form.errors[props.id] && form.touched[props.id])}
                            value={props?.value || field?.value || ''}
                            onChange={({ target }) => {
                                const value = target.value || ''
                                if(!preventFormikSetValue) form.setFieldValue(field.name, value, false);
                                if(customChange) customChange(field.name, value)
                            }}
                            onBlur={() => {
                                form.setTouched({ ...form.touched, [field.name]: true });
                            }}
                        />
                        {   
                            Boolean(form.errors[props.id] && form.touched[props.id]) &&
                            <small className="error input-feedback">{form.errors[props.id]}</small>
                        }
                        {/* <ErrorMessage className="error input-feedback" component="div" name={props.id} /> */}
                    </div>
                )}
            </Field>
        </div>
	);
};

export default PasswordTextInput;